import {
    Typography,
    IconButton,
    Grid,
    Paper,
    useTheme,
    Button,
    Popper,
    Grow,
    ClickAwayListener,
    MenuList,
    MenuItem,
    Box,
    useMediaQuery
} from '@mui/material'
import {
    Close,
    KeyboardArrowDown,
    Search,
} from '@mui/icons-material'
import { FC, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Dayjs } from 'dayjs';

import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { useActions } from '../../../hooks/useActions';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';

import { GridAnnouncementsStyle, SearchTextFieldStyle } from '../Announcements/styled';

import { oops } from '../../../assets/icons';

import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import AnnouncementItem from '../../../components/AnnouncementItem';
import ButtonDatePicker from '../../../components/Button/ButtonDatePicker';
import Reporting from '../HomePage/reportingSmall';
import Contacts from '../HomePage/contacts';

import "dayjs/locale/uk";


interface ISearchBy {
    label: string,
    property: string
}
const options: Array<ISearchBy> = [{ label: 'За тегом', property: "hashtag" }, { label: 'За описом', property: "description" }, { label: 'За заголовком', property: "title" }];

interface IProps {
    rowsPerPage: number
}

const Projects: FC<IProps> = ({ rowsPerPage }) => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const { GetNovelties, AddNovelties } = useActions();
    const { announcements, announcementsCount } = useTypedSelector((store) => store.announcementUser);


    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Проєкти", urlSlug: "" },
    ]);

    const [page, setPage] = useState<number>(1);
    const [searchBy, setSearchBy] = useState<string>("title");
    const [search, setSearch] = useState<string>("");
    const [date, setDate] = useState<Dayjs | null>(null);


    useEffect(() => {
        document.title = `Проєкти`;

        if (page === 1)
            getData(null);
        else
            addData();
    }, [page])

    const getData = async (newDate: Dayjs | null) => {
        try {
            await GetNovelties(true, searchBy, search, page, rowsPerPage, newDate !== null ? newDate : date);
        } catch (ex) {
        }
    };
    const addData = async () => {
        try {
            await AddNovelties(true, searchBy, search, page, rowsPerPage, date);
        } catch (ex) {
        }
    };

    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const [open, setOpen] = useState(false);
    const anchorRefMd = useRef<any>(null);
    const anchorRef = useRef<any>(null);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLLIElement, MouseEvent>,
        index: number,
    ) => {
        setSelectedIndex(index);
        setSearchBy(options[index].property)
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setOpen(false);
    };

    return (
        <>
            <Grid item xs={4} md={5} lg={12} sx={{ mb: { xs: "26px", md: "28px", lg: "20px" } }}>
                <BreadcrumbsComponent elements={breadcrumbs} />
            </Grid>
            <Grid item md={1} lg={2} sx={{ display: { xs: "none", md: "block" } }}>
                <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ md: "24px", lg: "36px" }} lineHeight="38px" >
                    Проєкти
                </Typography>
            </Grid>
            <Grid item xs={4} sx={{ display: { xs: "none", lg: "block" } }} />
            {/* md/lg */}
            <Grid item md={4} lg={6} sx={{ display: { xs: "none", md: "flex" }, justifyContent: "end", alignItems: "center" }}>
                <ButtonDatePicker
                    value={date}
                    setValue={(newValue: Dayjs | null) => {
                        setDate(newValue)
                        if (page == 1)
                            getData(newValue);
                        else
                            setPage(1)
                    }}
                />
                <Button
                    ref={anchorRefMd}
                    variant="contained"
                    onClick={handleToggle}
                    sx={{
                        height: "32px",
                        textTransform: "inherit",
                        fontsize: "14px",
                        lineHeight: "22px",
                        px: "16px",
                        background: palette.primary.dark,
                        mr: "12px"
                    }}
                    endIcon={<KeyboardArrowDown />}
                >
                    {options[selectedIndex].label}
                </Button>
                <Popper
                    sx={{ zIndex: 1 }}
                    open={open}
                    anchorEl={anchorRefMd.current}
                    role={undefined}
                    transition
                    disablePortal
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin:
                                    placement === 'bottom' ? 'center top' : 'center bottom',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList id="split-button-menu" autoFocusItem sx={{ p: "4px" }}>
                                        {options.map((option, index) => (
                                            <MenuItem
                                                key={`search_by_${option.property}`}
                                                selected={index === selectedIndex}
                                                onClick={(event) => handleMenuItemClick(event, index)}
                                                sx={{ borderRadius: "4px" }}
                                            >
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
                <SearchTextFieldStyle
                    value={search}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setSearch(e.target.value) }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.code == 'Enter') {
                            if (page == 1)
                                getData(null);
                            else
                                setPage(1)
                        }
                    }}
                    placeholder="Шукати..."
                />
                <IconButton size="large"
                    disableRipple
                    sx={{
                        p: "4px 0px",
                        ml: "6px"
                    }}
                    onClick={() => {
                        if (page == 1)
                            getData(null);
                        else
                            setPage(1)
                    }}
                >
                    <Search />
                </IconButton>
            </Grid>
            {/* xs */}
            <Grid item xs={4} sx={{ display: { xs: "flex", md: "none" }, justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize="26px" lineHeight="38px" >
                    Проєкти
                </Typography>
                <Box sx={{ display: "flex" }}>
                    <ButtonDatePicker
                        value={date}
                        setValue={(newValue: Dayjs | null) => {
                            setDate(newValue)
                            if (page == 1)
                                getData(newValue);
                            else
                                setPage(1)
                        }}
                    />
                    <Button
                        ref={anchorRef}
                        variant="contained"
                        onClick={handleToggle}
                        sx={{
                            maxWidth: "114px",
                            height: "32px",
                            textTransform: "inherit",
                            fontsize: "14px",
                            lineHeight: "22px",
                            px: "16px",
                            background: palette.primary.dark,
                            mr: "3px",
                        }}
                        endIcon={<KeyboardArrowDown />}
                    >
                        <Typography
                            noWrap
                            fontSize="inherit"
                        >
                            {options[selectedIndex].label}
                        </Typography>
                    </Button>
                    <Popper
                        sx={{ zIndex: 1 }}
                        open={open}
                        anchorEl={anchorRef.current}
                        role={undefined}
                        transition
                        disablePortal
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin:
                                        placement === 'bottom' ? 'center top' : 'center bottom',
                                }}
                            >
                                <Paper>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <MenuList id="split-button-menu" autoFocusItem sx={{ p: "4px" }}>
                                            {options.map((option, index) => (
                                                <MenuItem
                                                    key={`search_by_${option.property}`}
                                                    selected={index === selectedIndex}
                                                    onClick={(event) => handleMenuItemClick(event, index)}
                                                    sx={{ borderRadius: "4px" }}
                                                >
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>

                    <IconButton size="large"
                        disableRipple
                        sx={{
                            p: "4px 0px"
                        }}
                        onClick={() => {
                            setIsSearchOpen(!isSearchOpen)
                        }}
                    >
                        {isSearchOpen
                            ? <Close />
                            : <Search />}
                    </IconButton>
                </Box>
            </Grid >
            <Grid item xs={4} sx={{ display: { xs: (isSearchOpen ? "flex" : "none"), md: "none" }, justifyContent: "space-between", alignItems: "center", mt: "10px", px: "3px" }}>
                <SearchTextFieldStyle
                    value={search}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setSearch(e.target.value) }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.code == 'Enter') {
                            if (page == 1)
                                getData(null);
                            else
                                setPage(1)
                        }
                    }}
                    placeholder="Шукати..."
                />
                <Button
                    variant="contained"
                    sx={{
                        height: "32px",
                        textTransform: "inherit",
                        fontsize: "14px",
                        lineHeight: "22px",
                        px: "16px",
                        background: palette.primary.dark,
                        ml: "16px",
                    }}
                    onClick={() => {
                        if (page == 1)
                            getData(null);
                        else
                            setPage(1)
                    }}
                >
                    Пошук
                </Button>
            </Grid>
            {announcements.length !== 0
                ? <GridAnnouncementsStyle item xs={4} md={5} lg={12} sx={{ mt: { xs: "28px", lg: "34px" }, mx: { xs: "0px", md: "6.5px", lg: "0px" } }}>
                    {announcements.map((row, index) => {
                        return (
                            <Box key={row.urlSlug} sx={{ marginRight: { xs: "0px", md: "18px", lg: "32px" }, marginBottom: { xs: "15px", md: "18px", lg: "28px" } }}>
                                <AnnouncementItem isProject={true} urlSlug={row.urlSlug} title={row.title} description={row.description} imagePreview={row.imagePreview} date={row.date} announcementTime={row.announcementTime} hashtags={row.hashtags} />
                            </Box>
                        );
                    })}
                </GridAnnouncementsStyle>
                : <Grid item xs={4} md={5} lg={12} sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: { xs: "40px", md: "64px", lg: "115px" }, mx: { xs: "48px", md: "0px" } }}>
                    <img
                        loading="lazy" src={oops} alt="oops" style={{ width: "40px", height: "40px" }} />
                    <Typography variant="h4" fontFamily="Fixel Display, sans-serif" color="primary.main" textAlign="center" sx={{ mt: "24px" }}>
                        Наші системи трохи заплутались у фільтрах.
                    </Typography>
                    <Typography variant="h5" fontFamily="Fixel Display, sans-serif" textAlign="center" sx={{ mt: "15px" }}>
                        Оновіть пошук або перегляньте інші пропозиції!
                    </Typography>
                </Grid>
            }
            {announcements.length !== announcementsCount && <Grid item xs={4} md={5} lg={12} sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                    variant="outlined"
                    color="inherit"
                    sx={{
                        textTransform: "inherit",
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: "500",
                        fontFamily: "Fixel Display, sans-serif",
                        borderColor: palette.primary.main,
                        borderRadius: "12px",
                        p: "8px 26px"
                    }}
                    onClick={() => { setPage(page + 1) }}
                >
                    Показати ще...
                </Button>
            </Grid>}
            {/* Наша звітність */}
            <Reporting />
            {/* Контакти */}
            <Contacts />
        </>
    )
}

export default Projects